import { Component, OnInit, ViewChild, NgModule } from '@angular/core';
import { LocalstorageService } from '../../../global/localstorage.service';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  getlen: string;
  @ViewChild("ddllanguage", { static: false }) ddllanguage;
  footerLan: string;
  addLan: string;
  mobileLan: string;

  constructor() { }
  selected = '';

  language = [
    {value: 'en', viewValue: 'English'},
    {value: 'hi', viewValue: 'हिंदी'},
    {value: 'pn', viewValue: 'ਪੰਜਾਬੀ'}
  ];

  ngOnInit() {
   // debugger;
    this.getlen = LocalstorageService.getLanguage("language");
   // console.log(this.getlen)
    if (this.getlen == null) {
      LocalstorageService.setLanguage("language", "en");
      this.selected = "en";
    }
    else {
      this.getlen = LocalstorageService.getLanguage("language");
      LocalstorageService.setLanguage("language", this.getlen);
      this.selected = this.getlen;
    }
 //   debugger;
    if(this.getlen == "en") {
      this.footerLan = "Chandigarh Transport Undertaking(CTU)";
      this.addLan = "Plot No 701,Industrial Area,Phase-I,Chandigarh, PIN Code-160002";
      this.mobileLan = "18002747400";
    } else if (this.getlen == "hi") {
      this.footerLan = "चंडीगढ़ ट्रांसपोर्ट अंडरटेकिंग (सी.टी.यू.)";
      this.addLan = "प्लॉट नंबर 701,औद्योगिक क्षेत्र,फेज-I,चंडीगढ़, पिन कोड-160002";
      this.mobileLan = "18002747400";
    } else if (this.getlen == "pn") {
      this.footerLan = "ਚੰਡੀਗੜ੍ਹ ਟਰਾਂਸਪੋਰਟ ਅੰਡਰਟੇਕਿੰਗ (ਸੀ.ਟੀ.ਯੂ.)";
      this.addLan = "ਪਲਾਟ ਨੰ ੭੦੧,ਉਦਯੋਗਿਕ ਖੇਤਰ,ਫੇਜ਼-1,ਚੰਡੀਗੜ੍ਹ, ਪਿੰਨ ਕੋਡ-160002";
      this.mobileLan = "18002747400";
    } else {
      this.footerLan = "Chandigarh Transport Undertaking(CTU)";
      this.addLan = "ਪਲਾਟ ਨੰ ੭੦੧, ਇੰਡਸਟਰੀਅਲ ਏਰੀਆ, ਫੇਜ਼-1, ਚੰਡੀਗੜ੍ਹ, ਪਿੰਨ ਕੋਡ-160002";
      this.mobileLan = "18002747400";
    }
  }

  onLanguageChange(event) {
  //  debugger;
    const newVal = event;
    LocalstorageService.setLanguage("language", newVal);
    this.selected = newVal;
    window.location.reload();
  }
}
